module.exports = __webpack_public_path__ + "img/4.73f34744.png";